export default __webpack_public_path__ + "static/media/Trio-Soprano.fa4ec43a.mp3";